// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"cc7933dc","187":"1473fb42","295":"93982f9b","307":"365ba785","367":"52954500","378":"e54f61d5","442":"32f3a584","514":"b3eee92b","649":"b8695191","709":"6223b5ea","726":"3d6398e2","789":"077486cc","878":"1d9543ab","956":"490d01cf"}[chunkId] + ".chunk.js";
};